module.exports = __webpack_public_path__ + "img/ChristianLudwig_140x140_rund.9675ec58.jpg";